import React, { Fragment, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import { ToastContainer } from "react-toastify";
import MarketNavbar from "../MarketNav/MarketNavbar";
import MarketplacePage from "../components/MarketplacePage";
import QuickAddSizeModal from "./QuickAddSizeModal";
import { CartContext } from "../../../Context/CartContext";
import useQuickAddToCart from "../libs/useQuickAddToCart";
import { getListingConfig } from "../libs/categoryRoutes";
import useInfiniteProducts from "../libs/useInfiniteProducts";
import useInfiniteScroll from "../libs/useInfiniteScroll";
import ProductGrid from "./ProductGrid";
import ProductGridSkeleton from "./ProductGridSkeleton";
import Spinner from "../../../Spinner/Spinner";
import "../ProductCategory/ProductCategory.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-toastify/dist/ReactToastify.css";

const ProductListingPage = () => {
  const { pathname } = useLocation();
  const config = getListingConfig(pathname);
  const { addItemToCart } = useContext(CartContext);
  const { quickAdd, pending, confirmSize, cancelSize } = useQuickAddToCart(addItemToCart);

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteProducts(
    config?.queryKey || "products",
    config?.apiPath || "all-products"
  );

  const lastElementRef = useInfiniteScroll(fetchNextPage, hasNextPage, isFetchingNextPage);

  const handleAddToCart = (product) => quickAdd(product);

  if (!config) {
    return (
      <>
        <MarketNavbar />
        <p style={{ fontFamily: "Montserrat", textAlign: "center", padding: 40 }}>
          Category not found. <Link to="/market">Back to marketplace</Link>
        </p>
      </>
    );
  }

  if (isLoading) {
    return (
      <Fragment>
        <MarketNavbar />
        <MarketplacePage className="marketplace-page--flush-top">
          <div className="product-category-mothers">
            <div className="heading">
              <div className="wrapper">
                <Skeleton width={48} height={14} borderRadius={4} />
                <Skeleton width={12} height={14} borderRadius={4} />
                <Skeleton width={72} height={14} borderRadius={4} />
              </div>
              <span>
                <Skeleton width={220} height={28} borderRadius={6} />
              </span>
              <ProductGridSkeleton count={12} />
            </div>
          </div>
        </MarketplacePage>
        <ToastContainer position="top-right" className="toast" />
      </Fragment>
    );
  }

  if (isError) {
    return (
      <>
        <MarketNavbar />
        <p style={{ fontFamily: "Montserrat", textAlign: "center", padding: 40 }}>
          Error loading products.
        </p>
      </>
    );
  }

  return (
    <Fragment>
      <MarketNavbar />
      <MarketplacePage className="marketplace-page--flush-top">
      <div className="product-category-mothers">
        <div className="heading">
          <div className="wrapper">
            <Link to="/market">Home</Link>
            <MdKeyboardDoubleArrowRight />
            <p>{config.breadcrumb}</p>
          </div>
          <span>
            <h3>{config.title}</h3>
          </span>
          <ProductGrid
            pages={data?.pages || []}
            productsKey={config.productsKey}
            lastElementRef={lastElementRef}
            onAddToCart={handleAddToCart}
          />
          {isFetchingNextPage && (
            <div className="loading-more"><Spinner /></div>
          )}
        </div>
      </div>
      </MarketplacePage>
      <QuickAddSizeModal pending={pending} onConfirm={confirmSize} onCancel={cancelSize} />
      <ToastContainer position="top-right" className="toast" />
    </Fragment>
  );
};

export default ProductListingPage;
